import Phaser from 'phaser';
import { Boot } from './scenes/Boot.js';
import { Preload } from './scenes/Preload.js';
import { Menu } from './scenes/Menu.js';
import { LevelSelect } from './scenes/LevelSelect.js';
import { Game } from './scenes/Game.js';
import { LevelComplete } from './scenes/LevelComplete.js';

const config = {
  type: Phaser.AUTO,
  parent: 'game-canvas-mount',
  width: 960,
  height: 384,
  // Comic-art overhaul: white page background instead of the old dark
  // cyberpunk purple — the supplied art is drawn as black linework on
  // transparent PNGs, meant to sit on a light page like a print comic.
  backgroundColor: '#ffffff',
  // The comic-art overhaul uses smooth ink/line-art PNGs, not pixel art —
  // nearest-neighbor filtering (pixelArt: true) would make thin linework
  // look jagged when scaled, so this uses normal bilinear filtering instead.
  pixelArt: false,
  antialias: true,
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { y: 1400 },
      debug: false
    }
  },
  input: {
    gamepad: true
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_HORIZONTALLY
  },
  scene: [Boot, Preload, Menu, LevelSelect, Game, LevelComplete]
};

// eslint-disable-next-line no-new
new Phaser.Game(config);

document.getElementById('play-button')?.addEventListener('click', () => {
  document.getElementById('play')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

document.getElementById('fullscreen-button')?.addEventListener('click', () => {
  const container = document.getElementById('game-container');
  if (document.fullscreenElement) {
    document.exitFullscreen();
  } else {
    container?.requestFullscreen?.();
  }
});

// Cookie consent banner — gtag.js itself already defaults analytics_storage
// to 'denied' (see index.html's Consent Mode setup) regardless of this UI,
// so this is just what lets a visitor actually grant/decline that and have
// it remembered, rather than the choice being silently made for them.
const cookieBanner = document.getElementById('cookie-banner');
if (cookieBanner && !localStorage.getItem('cookie-consent')) {
  cookieBanner.hidden = false;
}

document.getElementById('cookie-accept')?.addEventListener('click', () => {
  localStorage.setItem('cookie-consent', 'granted');
  window.gtag?.('consent', 'update', { analytics_storage: 'granted' });
  cookieBanner.hidden = true;
});

document.getElementById('cookie-decline')?.addEventListener('click', () => {
  localStorage.setItem('cookie-consent', 'denied');
  cookieBanner.hidden = true;
});
